import {createCallable} from './createCallable';

export interface PopulateDataResult {
  moduleId: string;
  seedQuestionCount: number;
  questionCount: number;
  studyCount: number;
  tradingTradeCount?: number;
}

export const devPopulateData = createCallable<void, PopulateDataResult[]>('populateData');
